<template>
    <div class="video" >
        <div class="item" v-for="(item, index) in videoList" :class="{ 'full': item.isFull }" :key="item.id">
            <div class="box">
                <video width="100%" muted :id="item.ref" height="100%" style="object-fit:fill"></video>
            </div>
            <div class="inall" v-if="!item.isFull">
                <span @click="full(item, index)">
                    全屏
                </span>
            </div>
            <div v-else class="all" @click="full(item, index)">
                取消全屏
            </div>
            <div class="name">{{ item.name }}</div>

            <Photovoltaic v-if="PhotovoltaicShow && index == 0"></Photovoltaic>
        </div>
    </div>
</template>

<script>
import { _getProjectCamera, _getCameraPlayAddress } from '../../api/power.js'
import Hls from 'hls.js'
import Photovoltaic from './Photovoltaic';
export default {
    components: {
        Photovoltaic
    },
    data() {
        return {
            videoList2: [
                {
                    id: 1,
                    isFull: false,
                    ref: 'video5',
                    hls: null,
                    video: null,
                }],
            videoList: [
                {
                    id: 1,
                    isFull: false,
                    ref: 'video1',
                    hls: null,
                    video: null,
                    name:""
                },
                {
                    id: 2,
                    isFull: false,
                    ref: 'video2',
                    hls: null,
                    video: null,
                    name:""
                },
                // {
                //     id: 3,
                //     isFull: false,
                //     ref: 'video3',
                //     hls: null,
                //     video: null,
                //     name:""
                // },
                // {
                //     id: 4,
                //     isFull: false,
                //     ref: 'video4',
                //     hls: null,
                //     video: null,
                //     name:""
                // },
            ],
            buoomShow: false,
            operation: false,
            PhotovoltaicShow:false
        }
    },
    computed: {
        
    },
    mounted() {
        
        this.getProjectCamera()
    },
    methods: {
        
        full(item, index) {
            this.videoList[index].isFull = !this.videoList[index].isFull
            if (index == 0) {
                if (this.videoList[index].isFull) {
                    this.PhotovoltaicShow = true
                } else {
                    this.PhotovoltaicShow = false
                }
            }
        },
        async getProjectCamera() {
            try {
                let res = await _getProjectCamera({
                    projectId: this.$store.getters.projectId
                })

                let list = res.data.data.devices.filter(item => {
                    let camera = JSON.parse(item.device_details)
                    return camera.ysyDeviceSerial
                })
                console.log(list);
                this.showCamera(list)
            } catch (err) {
                console.log(err)
            }

        },
        showCamera(list) {
            let _this = this

            let showCameraList = []
            // e.device_id=='507'||e.device_id=='508'||e.device_id=='509'||e.device_id=='619'
            
            showCameraList = list.filter(e=>e.device_id=='507'||e.device_id=='509')
            
            console.log(showCameraList)

            showCameraList.forEach(async (item, index) => {
                let camera = JSON.parse(item.device_details)
                let sys = await _getCameraPlayAddress({
                    channelNo: camera.ysyChannel,
                    deviceSerial: camera.ysyDeviceSerial,
                    protocol: 2
                })
                _this.videoList[index]['name'] = item.device_name
                _this.getStream(sys.data.data, _this.videoList[index].ref)
                // if(index==0){
                //     _this.getStream2(sys.data.data, _this.videoList2[index].ref)
                // }

            })
        },
        getStream(url, id) {
            if (Hls.isSupported()) {
                let current = this.videoList.find(item => item.ref == id)
                console.log(current);
                if (!current.hls) {
                    current.hls = new Hls()
                    current.video = document.getElementById(id);

                    current.hls.loadSource(url);
                    current.hls.attachMedia(current.video)
                    current.hls.on(Hls.Events.MANIFEST_PARSED, () => {
                        current.video.play();
                        console.log("加载成功");
                    });
                }

            }
        },
        getStream2(url, id) {
            if (Hls.isSupported()) {
                let current = this.videoList2.find(item => item.ref == id)
                console.log(current);
                if (!current.hls) {
                    current.hls = new Hls()
                    current.video = document.getElementById(id);

                    current.hls.loadSource(url);
                    current.hls.attachMedia(current.video)
                    current.hls.on(Hls.Events.MANIFEST_PARSED, () => {
                        current.video.play();
                        console.log("加载成功");
                    });
                }

            }
        },
    }

}
</script>

<style scoped lang="less">
 .video {
        position: absolute;
        bottom: 25px;
        right: 1%;
        color: #ffffff;
        z-index: 9;
        width: 446px;

        .item {
            width: 191px;
            display: inline-block;
            margin: 0 16px;
            position: relative;

            .box {
                width: 100%;
                height: 134rem;
                position: relative;
            }

            .inall {
                position: absolute;
                color: #ffffff;
                bottom: 70rem;
                right: 0;
                font-size: 14px;
                padding: 0 10rem;
                text-align: right;
                cursor: pointer;
            }
        }

        .name {
            font-size: 18rem;
            font-family: Source Han Sans CN;
            font-weight: 500;
            color: #E2EBF1;
            line-height: 50px;
        }

        .full {
            width: 100vw;
            height: 100vh;
            position: fixed;
            top: 0;
            left: 0;
            z-index: 10;
            background-color: #000000;
            margin: 0;

            .box {
                // position: absolute;
                // width: 100%;
                // height: 100%;
                // z-index: 11;
                position: absolute;
                width: 1536px;
                height: 937px;
                left: 50%;
                top: 50%;
                margin-left: -768px;
                margin-top: -468px;
                transform: translate(0, 0);
            }

            .name {
                display: none;
            }

            .all {
                position: fixed;
                color: #ffffff;
                bottom: 20px;
                right: 0;
                font-size: 20px;
                padding: 0 10rem;
                text-align: right;
                cursor: pointer;
                z-index: 11;
            }
        }
    }
</style>